import { Bar, BarChart, CartesianGrid, Legend, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import type { MouseHandlerDataParam } from "recharts/types/synchronisation/types";

export interface GroupedBarDatum {
  label: string;
  selected: number;
  previous: number;
}

interface Props {
  data: GroupedBarDatum[];
  selectedName: string;
  previousName: string;
  valueFormatter?: (n: number) => string;
  onBarClick?: (datum: GroupedBarDatum) => void;
}

export function GroupedBarChart({ data, selectedName, previousName, valueFormatter, onBarClick }: Props) {
  function handleClick(s: MouseHandlerDataParam) {
    const idx = typeof s?.activeTooltipIndex === "number" ? s.activeTooltipIndex : -1;
    const datum = idx >= 0 ? data[idx] : undefined;
    if (datum != null && onBarClick) onBarClick(datum);
  }

  return (
    <ResponsiveContainer width="100%" height={320}>
      <BarChart data={data} width={600} height={320} onClick={handleClick}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="label" />
        <YAxis tickFormatter={valueFormatter} />
        <Tooltip
          formatter={(value) =>
            valueFormatter ? valueFormatter(value as number) : String(value)
          }
        />
        <Legend />
        <Bar dataKey="selected" name={selectedName} fill="var(--color-primary, #2563eb)" />
        <Bar dataKey="previous" name={previousName} fill="var(--color-muted-foreground, #9ca3af)" />
      </BarChart>
    </ResponsiveContainer>
  );
}
